import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { BigTitle } from 'shared/components/BigTitle';
import { Block } from 'shared/components/Block';
import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { IPOTEKA_PARTNER } from 'shared/constants/links';
import { DESCRIPTION, LIST } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const MainDirections: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.FinPlatform}>
          <Block>
            <BigTitle text="Основные направления" />
            <TextInfoWithImage
              title="Финансовая платформа"
              description={DESCRIPTION}
              list={LIST}
              image="cian-logo"
              btnLink={IPOTEKA_PARTNER}
            />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
